export const AGREEMENT_LINKS = {
  customer_agreement: {
    displayName: 'Customer Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=customer_agreement',
  },
  api_agreement: {
    displayName: 'API Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=api_agreement',
  },
  privacy_notification: {
    displayName: 'Privacy/CIP Notification',
    url: 'https://api.tradier.com/v2/applications/agreements?key=privacy_notification',
  },
  bcp: {
    displayName: 'Business Continuity',
    url: 'https://api.tradier.com/v2/applications/agreements?key=bcp',
  },
  edelivery_agreement: {
    displayName: 'Electronic Delivery Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=edelivery_agreement',
  },
  w9_certification: {
    displayName: 'W9 Certification',
    url: 'https://api.tradier.com/v2/applications/agreements?key=w9_certification',
  },
  w8ben_certification: {
    displayName: 'W8-BEN Certification',
    url: 'https://api.tradier.com/v2/applications/agreements?key=w8ben_certification',
  },
  margin_agreement: {
    displayName: 'Margin Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=margin_agreement',
  },
  margin_disclosure: {
    displayName: 'Margin Disclosure Statement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=margin_disclosure',
  },
  limited_margin_agreement: {
    displayName: 'Limited Margin Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=limited_margin_agreement',
  },
  roth_ira_agreement: {
    displayName: 'Roth IRA Agreement/Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=roth_ira_agreement',
  },
  individual_ira_agreement: {
    displayName: 'Individual IRA Agreement/Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=individual_ira_agreement',
  },
  beneficiary_authorization: {
    displayName: 'Beneficiaries Authorization Form',
    url: 'https://api.tradier.com/v2/applications/agreements?key=beneficiary_authorization',
  },
  joint_agreement: {
    displayName: 'Joint Account Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=joint_agreement',
  },
  day_trading_disclosure: {
    displayName: 'Day-Trading Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=day_trading_disclosure',
  },
  electronic_signature: {
    displayName: 'Electronic Signature Acknowledgement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=electronic_signature',
  },
  extended_hours_disclosure: {
    displayName: 'Extended Hours Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=extended_hours_disclosure',
  },
  options_disclosure: {
    displayName: 'Options Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=options_disclosure',
  },
  option_agreement: {
    displayName: 'Option Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=option_agreement',
  },
  option_risk_disclosure: {
    displayName: 'Risk Disclosure for Uncovered Options',
    url: 'https://api.tradier.com/v2/applications/agreements?key=option_risk_disclosure',
  },
  fee_schedule: {
    displayName: 'Fee Schedule',
    url: 'https://api.tradier.com/v2/applications/agreements?key=fee_schedule',
  },
  order_routing_disclosure: {
    displayName: 'Order Routing Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=order_routing_disclosure',
  },
  acat_form: {
    displayName: 'ACAT Transfer Form',
    url: 'https://api.tradier.com/v2/applications/agreements?key=acat_form',
  },
  ach_agreement: {
    displayName: 'ACH Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=ach_agreement',
  },
  etp_risk_disclosure: {
    displayName: 'Exchange Traded Products Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=etp_risk_disclosure',
  },
  fractional_share_disclosure: {
    displayName: 'Fractional Share Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=fractional_share_disclosure',
  },
  form_crs_disclosure: {
    displayName: 'Form CRS Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=form_crs',
  },
  non_professional_attestment: {
    displayName: 'Non-professional Attestation',
    url: 'https://api.tradier.com/v2/applications/agreements?key=non_professional_attestment',
  },
  nyse_agreement: {
    displayName: 'NYSE Subscriber Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=nyse_agreement',
  },
  nasdaq_agreement: {
    displayName: 'Nasdaq Subscriber Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=nasdaq_agreement',
  },
  opra_agreement: {
    displayName: 'OPRA Subscriber Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=opra_agreement',
  },
  subscription_agreement: {
    displayName: 'Subscription Agreement',
    url: undefined,
  },
  crypto_risk_disclosure: {
    displayName: 'Apex Crypto Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements=key=crypto_risk_disclosure',
  },
  crypto_user_agreement: {
    displayName: 'Apex Crypto User Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements=key=crypto_user_agreement',
  },
  crypto_privacy_policy: {
    displayName: 'Apex Crypto Privacy Policy',
    url: 'https://api.tradier.com/v2/applications/agreements=key=crypto_privacy_policy',
  },
  futures_risk_disclosure: {
    displayName: 'Futures Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_risk_disclosure',
  },
  futures_options_risk_disclosure: {
    displayName: 'Futures Options Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_options_risk_disclosure',
  },
  futures_supplement_risk_disclosure: {
    displayName: 'Futures Supplement Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_supplement_risk_disclosure',
  },
  futures_electronic_trading_disclosure: {
    displayName: 'Futures Electronic Trading Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_electronic_trading_disclosure',
  },
  futures_uniform_notification: {
    displayName: 'Futures Uniform Notification',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_uniform_notification',
  },
  futures_average_price_disclosure: {
    displayName: 'Futures Average Price Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_average_price_disclosure',
  },
  futures_foreign_order_statement: {
    displayName: 'Futures Foreign Order Statement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_foreign_order_statement',
  },
  futures_cme_disclosure: {
    displayName: 'Futures CME Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_cme_disclosure',
  },
  futures_margin_disclosure: {
    displayName: 'Futures Margin Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_margin_disclosure',
  },
  futures_foreign_brokers: {
    displayName: 'Futures Foreign Brokers Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_foreign_brokers',
  },
  futures_introduced_customers_notice: {
    displayName: 'Futures Introduced Customers Notice',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_introduced_customers_notice',
  },
  futures_dorman_privacy_policy: {
    displayName: 'Futures Dorman Privacy Policy',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_dorman_privacy_policy',
  },
  futures_conflicts_of_interest: {
    displayName: 'Futures Conflicts of Interest',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_conflicts_of_interest',
  },
  futures_usa_patriot_aml_statement: {
    displayName: 'Futures USA Patriot AML Statement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_usa_patriot_aml_statement',
  },
  futures_crypto_disclosure: {
    displayName: 'Futures Crypto Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_crypto_disclosure',
  },
  futures_customer_agreement: {
    displayName: 'Futures Customer Agreement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_customer_agreement',
  },
  futures_prop_funds_letter: {
    displayName: 'Futures Proprietary Funds Letter',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_prop_funds_letter',
  },
  futures_electronic_delivery: {
    displayName: 'Futures Electronic Delivery',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_electronic_delivery',
  },
  futures_w9_certification: {
    displayName: 'Futures W9 Certification',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_w9_certification',
  },
  futures_auto_liquidation_disclosure: {
    displayName: 'Futures Auto Liquidation Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_auto_liquidation_disclosure',
  },
  futures_cme_marketdata_subscription: {
    displayName: 'Futures CME Market Data Subscription',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_cme_marketdata_subscription',
  },
  futures_virtual_currency_risk_disclosure: {
    displayName: 'Futures Virtual Currency Risk Disclosure',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_virtual_currency_risk_disclosure',
  },
  futures_nfa_investor_advisory: {
    displayName: 'Futures NFA Investor Advisory',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_nfa_investor_advisory',
  },
  futures_dorman_additional_risk_statement: {
    displayName: 'Futures Dorman Additional Risk Statement',
    url: 'https://api.tradier.com/v2/applications/agreements?key=futures_dorman_additional_risk_statement',
  },
};

export const DEFAULT_AGREEMENTS = {
  individual_cash: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  individual_margin: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'margin_agreement',
    'margin_disclosure',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  joint_cash_survivor: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'joint_agreement',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  joint_margin_survivor: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'joint_agreement',
    'margin_agreement',
    'margin_disclosure',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  rollover_ira: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'individual_ira_agreement',
    'beneficiary_authorization',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  roth_ira: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'roth_ira_agreement',
    'beneficiary_authorization',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  traditional_ira: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'individual_ira_agreement',
    'beneficiary_authorization',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  traditional_sep_ira: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'individual_ira_agreement',
    'beneficiary_authorization',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
  custodial_cash: [
    'customer_agreement',
    'api_agreement',
    'privacy_notification',
    'bcp',
    'edelivery_agreement',
    'day_trading_disclosure',
    'electronic_signature',
    'extended_hours_disclosure',
    'ach_agreement',
    'fee_schedule',
    'order_routing_disclosure',
    'fractional_share_disclosure',
    'form_crs_disclosure',
  ],
};
export const MD_AGREEMENTS = ['non_professional_attestment', 'nyse_agreement', 'nasdaq_agreement', 'opra_agreement'];
export const OPTION_AGREEMENTS = ['options_disclosure', 'option_agreement', 'option_risk_disclosure'];
export const CRYPTO_AGREEMENTS = ['crypto_risk_disclosure', 'crypto_user_agreement', 'crypto_privacy_policy'];
export const FUTURES_AGREEMENTS = [
  'futures_risk_disclosure',
  'futures_options_risk_disclosure',
  'futures_supplement_risk_disclosure',
  'futures_electronic_trading_disclosure',
  'futures_uniform_notification',
  'futures_average_price_disclosure',
  'futures_foreign_order_statement',
  'futures_cme_disclosure',
  'futures_margin_disclosure',
  'futures_foreign_brokers',
  'futures_introduced_customers_notice',
  'futures_dorman_privacy_policy',
  'futures_conflicts_of_interest',
  'futures_usa_patriot_aml_statement',
  'futures_crypto_disclosure',
  'futures_customer_agreement',
  'futures_prop_funds_letter',
  'futures_electronic_delivery',
  'futures_w9_certification',
  'futures_auto_liquidation_disclosure',
  'futures_cme_marketdata_subscription',
  'futures_virtual_currency_risk_disclosure',
  'futures_nfa_investor_advisory',
];

export const DOMESTIC_TAX_CERTIFICATION = 'w9_certification';
export const FOREIGN_TAX_CERTIFICATION = 'w8ben_certification';
export const FUTURES_ADDITIONAL_RISK = 'futures_dorman_additional_risk_statement';
